<template>
    <div style="text-align: left;" class="mx-2 mx-md-0 glass-theme fade-in-page">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-truck"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <div style="margin-top: 5px;">
            <div style="margin-bottom: 5px;">

                <b-alert variant="success" show style="display: inline-block; vertical-align: top;" class="glass-alert">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>CUSTOM</div>

                        <b-dropdown size="sm" variant="primary" id="dropdown-1" text="OPTIONS" class="m-2" style="font-size: 12px;">
                            <b-dropdown-item @click="get_all_pending_truck_assignment_deliveries()">GET ALL PENDING</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-alert>
                
                <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;" class="glass-alert">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT DATE RANGE</div>
                        <b-input
                            id="dates"
                            size="lg"
                            variant="dark"
                            :placeholder="[query.startDate, query.endDate].join(' - ')"
                            style="display: inline-block; width: 200px; font-size: 14px; font-weight: bold;"
                            class="responsive-input glass-input"
                            autocomplete="off"
                        ></b-input>
                        <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0 glass-btn">SEARCH</b-button>
                    </div>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" class="glass-alert" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>FILTER TRUCK</div>
                        <b-form-select size="lg" :options="packet.trucks" v-model="filter_on_truck" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="filter_truck" class="glass-select">
                            <b-form-select-option :value="null">ALL</b-form-select-option>
                            <b-form-select-option value="no_truck">NO TRUCK</b-form-select-option>
                        </b-form-select>
                    </div>
                </b-alert>
            </div>

            <div v-if="items.length > 0">
                <b-card no-body class="mb-1 glass-card">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="outline-primary" class="glass-btn-outline">TRUCK STATS</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                        <div class="p-2">
                            <b-button size="sm" variant="dark" :disabled="false" v-for="tt,ttid in trucks" v-bind:key="ttid" v-if="((trucks_stats[tt.value] || {}).val || 0) > 0" style="margin: 5px;" class="glass-btn-stats">
                                {{ (tt.text || '').toUpperCase() }} : {{ ( (trucks_stats[tt.value] || {}).val || 0) }} / {{ Object.keys(trucks_stats[tt.value].invs).length }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-card>
            </div>
        </div>

        <b-card-text>
            <div style="width: 100%; height: 100%;" v-if="items_being_loaded==true">
                <!-- <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                </loading> -->
            </div>

            <div v-else style="margin-top: 10px;">
                <div v-if="items.length > 0" style="position: relative;">
                    <div style="overflow-y: scroll; max-height: 600px;">
                        <div style="display: inline-block; vertical-align: top; margin: 5px;">
                            <h5 style="z-index:100; font-family: courier; font-weight: bold; color: #1e293b;">
                                DELIVERIES FOR {{ query.startDate }} TO {{ query.endDate }}
                            </h5>
                        </div>

                        <div v-for="(item, idx) in items" :key="idx" class="delivery-item" :class="{ 'fade-in-row': true }" :style="getDeliveryItemStyle(item, idx)" v-if="item.show_row == true">
                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background: linear-gradient(135deg, #1e293b, #0f172a); color: white; font-weight: bold; text-align: center; font-size: 13px;">
                                        <th style="border: 1px solid #334155; width: 50px; border-radius: 8px 0 0 0;" @click="sortby('rank_number')">
                                            RNK
                                        </th>
                                        <th style="border: 1px solid #334155; width: 200px;" @click="sortby('invoice_id')">
                                            INVOICE #
                                        </th>
                                        <th style="border: 1px solid #334155; width: 200px;" @click="sortby('fullname')">
                                            CUSTOMER
                                        </th>
                                        <th style="border: 1px solid #334155; width: 120px;" @click="sortby('phone')">
                                            PHONE
                                        </th>
                                        <th style="border: 1px solid #334155; width: 100px;" @click="sortby('n_items')">
                                            # ITEMS
                                        </th>
                                        <th style="border: 1px solid #334155; width: 100px;" @click="sortby('total_cubes')">
                                            # CUBES
                                        </th>
                                        <th style="border: 1px solid #334155; width: 150px;" @click="sortby('state')">
                                            STATE
                                        </th>
                                        <th style="border: 1px solid #334155; width: 150px;" @click="sortby('city')">
                                            CITY
                                        </th>
                                        <th style="border: 1px solid #334155; width: 150px;" @click="sortby('zipcode')">
                                            ZIPCODE
                                        </th>
                                        <th style="border: 1px solid #334155; width: 120px; border-radius: 0 8px 0 0;">
                                            ACTION
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="text-align: center; background: rgba(255, 248, 225, 0.8); font-size: 13px;">
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ item.rank_number }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.display_invoice_id || item.invoice_id) }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.fullname || '').toUpperCase() }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.phone || '').toUpperCase() }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.n_items || 0) }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.total_cubes || 0.0) }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.state || '').toUpperCase() }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.city || '').toUpperCase() }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            {{ (item.zipcode || '').toUpperCase() }}
                                        </td>
                                        <td style="border: 1px solid #d6d8db; padding: 8px;">
                                            <b-button size="sm" variant="dark" @click="show_row_details(item, item.show_items)" class="glass-btn-small">
                                                <span v-if="item.show_items">
                                                    HIDE ITEMS
                                                </span>
                                                <span v-else>
                                                    VIEW ITEMS
                                                </span>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="item.show_items" style="padding: 10px; background: rgba(255,255,255,0.5);">
                                <table style="width: 100%;">
                                    <thead>
                                        <tr style="background: linear-gradient(135deg, #e6ee9c, #dcedc8); text-align: center; font-size: 12px;">
                                            <th style="border: 1px solid black; width: 250px; padding: 6px;">
                                                GROUP NAME
                                            </th>
                                            <th style="border: 1px solid black; width: 250px; padding: 6px;">
                                                GROUP SKU
                                            </th>
                                            <th style="border: 1px solid black; width: 250px; padding: 6px;">
                                                PRODUCT NAME
                                            </th>
                                            <th style="border: 1px solid black; width: 250px; padding: 6px;">
                                                PRODUCT SKU
                                            </th>
                                            <th style="border: 1px solid black; width: 250px; padding: 6px;">
                                                PRD TYPE
                                            </th>
                                            <th style="border: 1px solid black; width: 50px; padding: 6px;">
                                                QTY
                                            </th>
                                            <th style="border: 1px solid black; width: 150px; padding: 6px;">
                                                STATE
                                            </th>
                                            <th style="border: 1px solid black; width: 150px; padding: 6px;">
                                                DELIVERY DATE
                                            </th>
                                            <th style="border: 1px solid black; width: 100px; padding: 6px;">
                                                COMMENTS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(element, eidx) in item.items" :key="eidx" style="font-size: 12px; text-align: center; background: rgba(255,255,255,0.7);" v-if="element.quantity > 0" class="fade-in-row" :style="{ animationDelay: `${eidx * 0.01}s` }">
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ element.parent_product_name }}
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ element.parent_product_sku }}
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ (element.product_name || element.product_sku) }}
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ element.product_sku }}
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                <div v-if="element.is_special" style="background: rgba(255, 192, 203, 0.8); padding: 3px; border-radius: 6px;">SPECIAL</div>
                                                <div v-else style="background: rgba(144, 238, 144, 0.6); padding: 3px; border-radius: 6px;">
                                                    REGULAR
                                                </div>
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ element.quantity }}
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                {{ states_dict[element.state] }}
                                            </td>
                                            <td :style="getDeliveryDateStyle(element)" style="border: 1px solid black; padding: 6px;">
                                                <date-picker v-model="element.delivery_date" format="YYYY-MM-DD" valueType="format" style="font-size: 12px; text-align: center; border: 1px solid rgba(128,128,128,0.3); width: 120px; border-radius: 8px;" @change="update_element_delivery_date(element)" class="glass-datepicker"></date-picker>
                                            </td>
                                            <td style="border: 1px solid black; padding: 6px;">
                                                <span v-if="comments_dict[element.invoice_id+'|'+element.itemid]">
                                                    <b-button size="sm" variant="outline-primary" @click="show_comments(element)" class="glass-btn-small">
                                                        VIEW ({{ comments_dict[element.invoice_id+'|'+element.itemid] }})
                                                    </b-button>
                                                </span>
                                                <span v-else>
                                                    <b-button size="sm" variant="outline-secondary" @click="show_comments(element)" class="glass-btn-small">VIEW
                                                    </b-button>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <b-alert show variant="warning" class="glass-alert">NO DELIVERIES</b-alert>
                </div>
            </div>
        </b-card-text>

        <b-modal id="modal-comments-process-deliveries" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'" class="glass-modal">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>
    </div>
</template>

<script>
    import Requestor from '@/utilities/Requestor';
    import moment from 'moment'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import ItemComments from '@/components/importables/ItemComments'
    import mappings from '@/utilities/mappings'

    export default {
        name: "AdminToolsProcessDeliveries",
        components: {Loading, ItemComments, DatePicker},
        data: function(){
            return {
                packet: {},
                items: [],
                dates: [],
                dates_being_loaded: true,
                trucks: [],
                trucks_dict: {},
                trucks_being_loaded: true,
                items_being_loaded: false,
                active_date: null,
                trucks_stats: {},
                sort_asc: true,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                states_dict: mappings.states_dict,
                query: {
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },
                filter_on_truck: null,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Deliveries',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "🚚 Loading delivery data...",
                    "📦 Fetching orders...",
                    "📍 Processing delivery routes...",
                    "📊 Calculating truck stats...",
                    "🔄 Syncing with server...",
                    "✨ Organizing delivery list...",
                    "🗺️ Updating delivery status..."
                ]
            }
        },
        computed: {
            currentTip() {
                return this.tips[this.currentTipIndex] || this.tips[0];
            }
        },
        methods: {
            getDeliveryItemStyle(item, idx) {
                return {
                    marginBottom: '10px',
                    border: '2px solid rgba(0,0,0,0.2)',
                    borderRadius: '12px',
                    background: 'rgba(255,255,255,0.7)',
                    backdropFilter: 'blur(5px)',
                    opacity: item.opacity,
                    animationDelay: `${idx * 0.03}s`
                };
            },
            getDeliveryDateStyle(element) {
                return {
                    border: '1px solid black',
                    padding: '6px',
                    background: (element.belongs_to_date == true) ? 'rgba(255,255,255,0.6)' : 'rgba(255, 235, 59, 0.4)'
                };
            },
            // Loading animation methods
            startApiLoading(message = 'Loading Deliveries') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Loading Deliveries') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Deliveries', 'Fetching Data', 'Processing Routes', 'Calculating Stats', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },
            
            search_dates: function(e) {
                if (e) {
                    e.preventDefault();
                }

                if (!this.query.startDate || !this.query.endDate) {
                    this.$bvToast.toast(
                        "Please select a date range.",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                    return;
                }

                this.get_process_delivery_items_for_date();
            },
            
            initDatePicker: function() {
                const Lightpick = require('lightpick');
                let that = this;
                
                var picker = new Lightpick({
                    field: document.getElementById('dates'),
                    singleDate: false,
                    repick: true,
                    format: 'YYYY-MM-DD',
                    onSelect: function(start, end) {
                        that.query.startDate = start ? start.format('YYYY-MM-DD') : '';
                        that.query.endDate = end ? end.format('YYYY-MM-DD') : '';
                        if (start && end) {
                            that.get_process_delivery_items_for_date();
                        }
                    }
                });
                
                picker.setDate(moment().toDate());
            },
            
            get_all_pending_truck_assignment_deliveries: function(e){
                if (e){
                    e.preventDefault();
                }
                this.startApiLoading('Loading Pending Deliveries');
                let that = this;
                let path = "/api/sales/get_all_pending_truck_assignment_deliveries/"
                let data = {
                    merchandise_status: [1],
                    order_type: "home_delivery",
                }

                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        for (var i=0; i<that.items.length; i++){
                            let it_items = that.items[i].items;
                            let trucks = it_items.map(function(d){
                                return d.truck
                            });

                            trucks = [...new Set(trucks)];
                            if (trucks.length == 1){
                                if (trucks[0] != null){
                                    that.items[i].truck = trucks[0]
                                }
                            }
                        }
                        that.update_trucks_stats();
                        that.get_batch_comments();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading pending truck assginment deliveries.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                this.items_being_loaded = true;
                this.items = [];
                this.filter_on_truck = null;
                Requestor.postSyncP(path, data, this, s, f);
            },
            filter_truck: function(){
                let truck = this.filter_on_truck;
                if (truck == 'ALL' || !truck || truck == null){
                    this.items = this.items.map(function(d){d.show_row = true; return d});
                }
                else {
                    if (truck == "no_truck"){
                        this.items = this.items.map(function(d){ if (d.truck == null){ d.show_row = true} else {d.show_row = false;} return d});
                    }
                    else {
                        this.items = this.items.map(function(d){ if (d.truck == truck){ d.show_row = true} else {d.show_row = false;} return d});
                    }
                }
                return
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid = item.itemid;
                this.$bvModal.show("modal-comments-process-deliveries");
            },
            update_trucks_stats: function(item){
                let that = this;

                if (item){
                    item.items = item.items.map(function(d){
                        d.truck = item.truck;
                        return d;
                    })
                    this.update_invoice_items_2(item);
                }

                this.trucks_stats = {}
                for (var i=0; i<this.items.length; i++){
                    let it = this.items[i];
                    let invoice_id = it.invoice_id;

                    for (var j=0; j<it.items.length; j++){
                        var el = it.items[j];
                        if (el.truck in this.trucks_stats){
                            this.trucks_stats[el.truck].val += (parseInt(el.cubes) * el.quantity || 0);
                            this.trucks_stats[el.truck].invs[it.display_invoice_id] = true;
                        }
                        else {
                            this.trucks_stats[el.truck] = {invs: {}, val: 0};
                            this.trucks_stats[el.truck].val = (parseInt(el.cubes) * el.quantity || 0);
                            this.trucks_stats[el.truck].invs[it.display_invoice_id] = true;
                        }
                    }
                }
                return
            },
            get_batch_comments: function(){
                console.log(this.items);

                let items = this.items.map(function(d){
                   return d.items.map(function(e){
                        return {invoice_id: e.invoice_id, itemid: e.itemid}
                   })
                })
                items = items.flat(1);
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        console.log(response.data.result);
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            console.log(that.comments_dict);
                        }
                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },

            update_invoice_items_2: function(item){
                let path = "/api/sales/update_invoice_items_2/"
                let data = {
                    invoice_id: item.invoice_id,
                    itemids: item.items.map(function(d){
                        return d.itemid
                    }),
                    truck: item.truck
                }
                let that = this;
                let s = function(response){
                    if (!response.data.error){
                        that.$bvToast.toast(
                            "Updated trucks for the invoice.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error updating trucks for the invoice.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            update_invoice_item_1: function(invoice_id, element){
                let path = "/api/sales/update_invoice_item_1/"
                let data = element;
                data.invoice_id = invoice_id;
                let that = this;
                let s = function(response){
                    if (!response.data.error){
                        that.$bvToast.toast(
                            "Updated item.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.update_trucks_stats();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error updating item.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            show_row_details: function(item, show_items){
                this.items = this.items.map(function(d){ d.show_items = false; return d;});
                if (item.show_items == false && show_items == true){
                    item.show_items = false;
                }
                else {
                    item.show_items = true;
                }
                return
            },
            
            get_all_no_truck_items: function(e){
                if (e){
                    e.preventDefault();
                }
                this.startApiLoading('Loading No Truck Items');
                let that = this;
                let path = "/api/sales/get_process_delivery_items_for_date/"
                let data = {
                    order_type: "home_delivery",
                    notruck: true,
                    startDate: this.query.startDate,
                    endDate: this.query.endDate
                }

                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        for (var i=0; i<that.items.length; i++){
                            let it_items = that.items[i].items;
                            let trucks = it_items.map(function(d){
                                return d.truck
                            });

                            trucks = [...new Set(trucks)];
                            if (trucks.length == 1){
                                if (trucks[0] != null){
                                    that.items[i].truck = trucks[0]
                                }
                            }
                        }
                        that.update_trucks_stats();
                        that.get_batch_comments();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading deliveries for date.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                this.items_being_loaded = true;
                this.items = [];
                this.filter_on_truck = null;
                Requestor.postSyncP(path, data, this, s, f);
            },

            get_process_delivery_items_for_date: function(){
                this.startApiLoading('Loading Deliveries');
                let that = this;
                let path = "/api/sales/get_process_delivery_items_for_date/"
                let data = {
                    startDate: this.query.startDate,
                    endDate: this.query.endDate,
                    merchandise_status: [1],
                    order_type: "home_delivery",
                }

                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        for (var i=0; i<that.items.length; i++){
                            let it_items = that.items[i].items;
                            let trucks = it_items.map(function(d){
                                return d.truck
                            });

                            trucks = [...new Set(trucks)];
                            if (trucks.length == 1){
                                if (trucks[0] != null){
                                    that.items[i].truck = trucks[0]
                                }
                            }
                        }
                        that.update_trucks_stats();
                        that.get_batch_comments();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading deliveries for date.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.stopApiLoading();
                }

                this.items_being_loaded = true;
                this.items = [];
                this.filter_on_truck = null;
                Requestor.postSyncP(path, data, this, s, f);
            },

            fetch_prereqs: function(order_type){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/user/get_trucks/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.trucks = response.data.result.map(function(d){
                                    return {
                                        value: d.id,
                                        text: d.name,
                                        cube_count: 0
                                    }
                                });
                                that.trucks.forEach((el, index) => that.trucks_dict[el.value] = el.text);
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error,
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            that.trucks_being_loaded = false;
                        },
                        f: function(error) {
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading trucks.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            update_element_delivery_date: function(element){
                let path = "/api/sales/update_element_delivery_date/"
                let data = element;
                let that = this;
                let s = function(response){
                    if (!response.data.error){
                        that.$bvToast.toast(
                            "Successfully updated item's delivery date.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item's delivery date",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            sortby: function(key, mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key, mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key, mapper)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        mounted: function() {
            this.initDatePicker();
            this.get_process_delivery_items_for_date();
        },
        beforeDestroy() {
            this.stopLoadingAnimation();
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.trucks.push({"value": "ALL", "text": "ALL"});
            this.packet.trucks = this.packet.trucks.filter(function(d){return d.value != null || d.text.length != 0});

            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs("home_delivery")
        }
    }
</script>

<style scoped>
    /* Glass Theme Background */
    .glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
    }

    .glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Page Entrance Animation */
    @keyframes fadeInPage {
        from {
            opacity: 0;
            transform: translateY(24px);
            filter: blur(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
            filter: blur(0);
        }
    }

    .fade-in-page {
        animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
    }

    /* Row Fade Animation */
    @keyframes fadeInRow {
        from {
            opacity: 0;
            transform: translateX(-8px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    .fade-in-row {
        opacity: 0;
        animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
    }

    /* Delivery Item */
    .delivery-item {
        margin-bottom: 10px;
        border: 2px solid rgba(0,0,0,0.2);
        border-radius: 12px;
        background: rgba(255,255,255,0.7);
        backdrop-filter: blur(5px);
    }

    /* Glass Alert */
    .glass-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 16px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Card */
    .glass-card {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        overflow: hidden;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        transition: all 0.2s ease !important;
        border-radius: 10px !important;
    }

    .glass-btn:hover:not(:disabled) {
        background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    }

    .glass-btn-outline {
        background: rgba(255, 255, 255, 0.8) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(54, 64, 80, 0.3) !important;
        transition: all 0.2s ease !important;
        border-radius: 10px !important;
    }

    .glass-btn-outline:hover {
        background: rgba(54, 64, 80, 0.1) !important;
        transform: translateY(-1px) !important;
    }

    .glass-btn-stats {
        background: rgba(54, 64, 80, 0.85) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.2s ease !important;
    }

    .glass-btn-stats:hover {
        background: rgba(54, 64, 80, 1) !important;
        transform: translateY(-1px) !important;
    }

    .glass-btn-small {
        background: rgba(54, 64, 80, 0.85) !important;
        color: white !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 4px 12px !important;
        transition: all 0.2s ease !important;
    }

    .glass-btn-small:hover {
        background: rgba(54, 64, 80, 1) !important;
        transform: translateY(-1px) !important;
    }

    /* Glass Input */
    .glass-input {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(128, 128, 128, 0.3) !important;
        border-radius: 10px !important;
    }

    .glass-input:focus {
        border-color: rgba(54, 64, 80, 0.5) !important;
        box-shadow: 0 0 0 2px rgba(54, 64, 80, 0.1) !important;
    }

    /* Glass Select */
    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(128, 128, 128, 0.3) !important;
        border-radius: 10px !important;
    }

    /* Glass Modal */
    .glass-modal >>> .modal-content {
        background: rgba(255, 255, 255, 0.98) !important;
        backdrop-filter: blur(20px) !important;
        border: 1px solid rgba(255, 255, 255, 0.5) !important;
        border-radius: 24px !important;
    }

    /* Glass Datepicker */
    .glass-datepicker >>> .mx-input {
        background: rgba(255, 255, 255, 0.9) !important;
        border: 1px solid rgba(128, 128, 128, 0.3) !important;
        border-radius: 8px !important;
    }

    /* Loading Overlay Styles */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Original Styles */
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 12px;
        background: white;
    }

    .pcol {
        padding: 5px;
        background: aliceblue;
    }

    .pcolh {
        font-size: 12px;
        font-weight: bold;
        background: gainsboro;
        margin-bottom: 3px;
    }

    .card-body {
        padding: 5px;
    }
    
    @media (max-width: 600px) {
        .responsive-input {
            width: 100% !important;
            display: block !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsProcessDeliveries.vue